import { render } from "./DealInformation.vue?vue&type=template&id=dc736f16&scoped=true"
import script from "./DealInformation.vue?vue&type=script&lang=js"
export * from "./DealInformation.vue?vue&type=script&lang=js"

import "./DealInformation.vue?vue&type=style&index=0&id=dc736f16&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc736f16"]])

export default __exports__